import { css } from 'styled-components'
import ofc from '../../settings/variables'
const styles = css`
    color:${ofc.primary};

`

export default styles
    